"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.DEBUG = exports.INFO = exports.ERROR = exports.WARN = void 0;
var default_configuration_1 = require("../config/default.configuration");
exports.WARN = 'warn';
exports.ERROR = 'error';
exports.INFO = 'info';
exports.DEBUG = 'debug';
/**
 * Logger Utils
 */
var Logger = /** @class */ (function () {
    /**
     * Instantiate Logger
     * @param configuration ILazyLoadConfiguration; by default DefaultConfiguration
     */
    function Logger(configuration) {
        if (configuration === void 0) { configuration = default_configuration_1.DefaultConfiguration; }
        this.configuration = configuration;
    }
    Logger.getInstance = function (configuration) {
        if (!this.instance) {
            this.instance = new Logger(configuration);
        }
        return this.instance;
    };
    /**
     * Set a custom configuration
     * @param configuration Custom configuration
     */
    Logger.prototype.setConfiguration = function (configuration) {
        this.configuration = configuration;
    };
    /**
     * Log message in warn if level is enabled
     * @param message a message
     * @param args arguments
     */
    Logger.prototype.warn = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (exports.WARN == this.configuration.logger.level
            || exports.ERROR == this.configuration.logger.level) {
            console.warn(message, args);
        }
    };
    /**
     * Log message in debug if level is enabled
     * @param message a message
     * @param args arguments
     */
    Logger.prototype.debug = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (exports.DEBUG == this.configuration.logger.level) {
            console.debug(message, args);
        }
    };
    /**
     * Log message in error if level is enabled
     * @param message a message
     * @param args arguments
     */
    Logger.prototype.error = function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        console.error(message, args);
    };
    return Logger;
}());
exports.Logger = Logger;
//# sourceMappingURL=logger.utils.js.map